import { FC, memo } from "react";
import { CheckCircle2Icon, MessageCircleWarningIcon } from "lucide-react";
const DeployCountDisplay: FC<{ count: number }> = memo(({ count }) => {
    const isFirstDeploy = count <= 1;

    return (
        <div
            className="flex items-center justify-center gap-1 p-1 rounded-md text-sm w-fit pr-2.5"
            style={{
                backgroundColor: isFirstDeploy ? "#57E18E29" : "#FF2B4529",
                color: isFirstDeploy ? "#57E18E" : "#FF2B45",
                borderRadius: "46px",
                borderColor: isFirstDeploy ? "#57E18EB2" : "#FF2B45B2",
                borderWidth: "1px",
            }}
        >
            {isFirstDeploy ? (
                <CheckCircle2Icon width={20} height={20} />
            ) : (
                <MessageCircleWarningIcon width={20} height={20} />
            )}
            {count}
        </div>
    );
});

DeployCountDisplay.displayName = "DeployCountDisplay";

export default DeployCountDisplay;
